<div *ngIf="isLoading" class="se-loader"></div>


<div class="hide-in-large mobile-support">
  <div class="top-div">
    <div class="coolers-list hide-in-mobile"> {{labels.deviceList | translate}}</div>
    <div class="filter-sec">
      <input #filtr [(ngModel)]="targetSearch" type="text" title={{labels.searchPalce|translate}} translate
             aria-label="search" class="input-globalsearch" size="50"
             placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
    </div>
  </div>
  <div class="container-fluid">
    <div *ngIf="noData" class="row mobile-coolers-list">
      <div class=" support-card">
        <div class="row ">
          <div class="col card-col noData">
            {{labels.noRecords | translate}}
          </div>
        </div>
      </div>
    </div>
    <p-tabView class="device-list-tabs" *ngIf="!noData" #DevicetabView (onChange)="onDeviceStatusTab($event)" [(activeIndex)]="tabDeviceStatus">
      <p-tabPanel class="device-tab-header" header="{{activeCoolersCount}} {{labels.activeDevices | translate}}">
        <div class="row mobile-coolers-list">
          <div class="card-mobile support-card" *ngFor="let cooler of coolersData | filterBy: targetSearch | filterArray:'true' ">
            <div *ngFor="let col of cols">
              <div class="row data-full-row" *ngIf="col.display==='auto' && ( col.field =='name' || col.field =='lastConnectedOn')">
                <div class="col card-col" *ngIf="col.showInMobileView==true">
                  <p class="mobile-grid-header" *ngIf="col.field !=='deviceStatus'">{{col.header|translate}}</p>
                  <p class="mobile-grid-data-full" *ngIf="col.field ==='lastConnectedOn'">
                    {{(cooler[col.field] | date : 'dd-MM-yyyy HH:mm')|| '&nbsp;' }}
                  </p>
                  <p class="mobile-grid-data-full" *ngIf="col.field =='name'">
                    {{cooler[col.field] || '&nbsp;'}}
                  </p>
                </div>
              </div>
              <div class="row data-row" *ngIf="col.display==='auto' && col.field !='name' && col.field !='lastConnectedOn'">
                <div class="col card-col" *ngIf="col.showInMobileView==true">
                  <p class="mobile-grid-header" *ngIf="col.field !=='isActive'">{{col.header|translate}}</p>
                  <p class="mobile-grid-data" *ngIf=" col.field !=='isActive'  && col.field !=='groups'">
                    {{cooler[col.field] || '&nbsp;'}}
                  </p>
                  <p class="mobile-grid-data" *ngIf="col.field =='groups'">
                    {{cooler[col.field].length==0? '&nbsp;' :cooler[col.field] }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row data-row flright">
              <div class="col card-col">
                <p class="mobile-grid-data">
                  <button *ngIf="cooler['lastConnectedOn']!=null" class="mobile-grid-data se-button button-primary float-right" (click)="ClickCommand('name',cooler.dongleUId,cooler.tag_name,cooler.lastConnectedOn,cooler.name,cooler.controllerTypeName,cooler.isWireless,cooler.id,cooler.mask,cooler.poli,cooler.firmwareVersion,cooler.controllerTypeId)">
                    {{labels.deviceDetails | translate}}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel class="device-tab-header" header="{{inactiveCoolersCount}} {{labels.inactiveDevices | translate}}">
        <div class="row mobile-coolers-list">
          <div class="card-mobile support-card" *ngFor="let cooler of coolersData | filterBy: targetSearch | filterArray : 'false' ">
            <div *ngFor="let col of cols">
              <div class="row data-full-row" *ngIf="col.display==='auto' && ( col.field =='name' || col.field =='lastConnectedOn')">
                <div class="col card-col" *ngIf="col.showInMobileView==true">
                  <p class="mobile-grid-header" *ngIf="col.field !=='isActive'">{{col.header|translate}}</p>
                  <p class="mobile-grid-data-full" *ngIf="col.field ==='lastConnectedOn'">
                    {{(cooler[col.field] | date : 'dd-MM-yyyy HH:mm')|| '&nbsp;' }}
                  </p>
                  <p class="mobile-grid-data-full" *ngIf="col.field =='name'">
                    {{cooler[col.field] || '&nbsp;'}}
                  </p>
                </div>
              </div>
              <div class="row data-row" *ngIf="col.display==='auto' && col.field !='name' && col.field !='lastConnectedOn'">
                <div class="col card-col" *ngIf="col.showInMobileView==true">
                  <p class="mobile-grid-header" *ngIf="col.field !=='isActive'">{{col.header|translate}}</p>
                  <p class="mobile-grid-data" *ngIf=" col.field !=='isActive'  && col.field !=='groups'">
                    {{cooler[col.field] || '&nbsp;'}}
                  </p>
                  <p class="mobile-grid-data" *ngIf="col.field =='groups'">
                    {{cooler[col.field].length==0? '&nbsp;' :cooler[col.field] }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row data-row flright">
              <div class="col card-col">
                <p class="mobile-grid-data">
                  <button *ngIf="cooler['lastConnectedOn']!=null" class="mobile-grid-data se-button button-primary float-right" (click)="ClickCommand('name',cooler.dongleUId,cooler.tag_name,cooler.lastConnectedOn,cooler.name,cooler.controllerTypeName,cooler.isWireless,cooler.id,cooler.mask,cooler.poli,cooler.firmwareVersion,cooler.controllerTypeId)">
                    {{labels.deviceDetails | translate}}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
<div class="hide-in-mobile">

  <div class="grid-div  mb-2">
    <div class="top-div">
      <div class="coolers-list hide-in-mobile"> {{labels.deviceList | translate}}</div>
      <div class="filter-sec">
        <button class="btn-filter" (click)='ToggleFilter(dt)'>
          <img src="assets/filter.svg" class="icon-filter" alt="filter" height="21" width="21"/> {{ labels.filter | translate }}
        </button>
      </div>
    </div>
    <div class="rectangle-grid">
      <p-table #dt [columns]="cols" [value]="coolersData" [paginator]="isPagination" [rows]="10" [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width, 'display': col.display }">
              {{ col.header | translate }}
              <p-sortIcon [field]="col.field" *ngIf="col.field !== 'alarm_Severity' && col.header!=='#'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" class="width2-6em"></th>
          </tr>
          <tr class="tHead-filter" *ngIf="showfilter">
            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display }" [attr.colspan]="col.field == 'deviceStatus' ? '2' : '1'">
              <input aria-label="search" pInputText type="text" class="search_field" (input)="dt.filter($event.target.value, col.field, 'contains')"
                     *ngIf="col.field !== 'deviceStatus' &&  col.field !== 'alarm_Severity' && col.header!=='#' && col.display=='auto' && col.header!==''&& col.field !== 'lastConnectedOn'">

              <p-calendar #lastConnDate *ngIf="col.field == 'lastConnectedOn'"
                          [(ngModel)]="LastConnDateFilter" class="calender_field" showButtonBar="true"
                          (ngModelChange)="calendarService.calendarDateChanged($event, lastConnDate, dt, 'lastConnectedOn', 'contains','yyyy-MM-dd')"
                          appendTo="body" readonlyInput="true" dateFormat="dd-MM-yy" placeholder="Select Date">
              </p-calendar>

              <div *ngIf="col.field == 'deviceStatus'">
                <label class="radio-filter">
                  <input type="radio" name="recordStatus" [value]='all' [(ngModel)]="recordStatus" (change)="recordStatusChange($event)" />
                  <span>{{labels.all | translate}}</span>
                </label><br />
                <label class="radio-filter">
                  <input type="radio" name="recordStatus" [value]='1' [(ngModel)]="recordStatus" (change)="recordStatusChange($event)" />
                  <span>{{labels.online | translate}}</span>
                </label>
                <label class="radio-filter">
                  <input type="radio" name="recordStatus" [value]='0' [(ngModel)]="recordStatus" (change)="recordStatusChange($event)" />
                  <span>{{labels.offline | translate}}</span>
                </label>
                <label class="radio-filter">
                  <input type="radio" name="recordStatus" [value]='3' [(ngModel)]="recordStatus" (change)="recordStatusChange($event)">
                  <span>{{labels.tableDataDeviceInActive | translate}}</span>
                </label>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [ngClass]="{'heigt2-9em':true,'selected_Row': rindex == i}">
            <td *ngFor="let col of columns" class="overflow-control" title="{{rowData[col.field]}}" [ngStyle]="{'display': col.display}">
              <span *ngIf="col.field=='alarm_Severity'">
                <img title="Critical Alarm" alt="Critical" width="15px" height="14px" *ngIf="rowData.alarm_Severity=='1'" src="assets/alarmSeverity2.svg" />
                <img title="Warning Alarm" alt="Warning" width="15px" height="14px" *ngIf="rowData.alarm_Severity=='2'" src="assets/alarmSeverity1.svg" />
              </span>
              <span *ngIf="col.header=='#'">
                {{i+1}}
              </span>
              <span *ngIf="col.field ==='lastConnectedOn'" appendTo="target" (click)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                    (keypress)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                    (keydown)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                    (keyup)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)">
                {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
              </span>
              <span class="txtwordwrap"
                    *ngIf="col.field !== 'alarm_Severity' && col.field !== 'lastConnectedOn' && col.field !== 'name' && col.field !== 'alarm_Count' && col.field !== 'deviceStatus' && col.field !== 'groups'"
                    appendTo="target" (click)="ClickCommand(col.field,rowData.cooler_uid,rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName,rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                    (keypress)="ClickCommand(col.field,rowData.cooler_uid,rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                    (keydown)="ClickCommand(col.field,rowData.cooler_uid,rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                    (keyup)="ClickCommand(col.field,rowData.cooler_uid,rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)">
                {{rowData[col.field]}}
              </span>
              <a class="hlink" *ngIf="rowData['lastConnectedOn']!=null">
                <span class="txtwordwrap" *ngIf="col.field =='name' || col.field =='alarm_Count'" appendTo="target"
                      (click)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName,rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                      (keypress)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                      (keydown)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)"
                      (keyup)="ClickCommand(col.field,rowData['dongleUId'],rowData.tag_name,rowData.lastConnectedOn,rowData.name,rowData.controllerTypeName, rowData.isWireless,rowData.id,rowData.mask,rowData.poli,rowData.firmwareVersion,rowData.controllerTypeId)">
                  {{rowData[col.field]}}
                </span>
              </a>
              <span class="txtwordwrap" *ngIf="rowData['lastConnectedOn']==null && col.field !== 'alarm_Severity' && (  col.field =='name' || col.field =='alarm_Count')">
                {{rowData[col.field]}}
              </span>
              <span *ngIf="col.field === 'deviceStatus'">
                {{ rowData[col.field] === 0 ? labels.offline :(rowData[col.field] === 1? labels.online :labels.tableDataDeviceInActive ) }}
              </span>
              <span *ngIf="col.field === 'groups'">
                {{ rowData[col.field] }}
              </span>
            </td>
            <td>
              <img title="Device location" class="locateIcon cursorPointerHand" *ngIf="rowData['locationCountry']!='' && rindex == i" src="assets/location_map_white.svg" width="150px" height="150px" alt="location map"
                   (click)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)"
                   (keypress)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)"
                   (keydown)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)"
                   (keyup)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)" />

              <img title="Device location" class="locateIcon cursorPointerHand" *ngIf="rowData['locationCountry']!='' && rindex != i" src="assets/location_map.svg" width="150px" height="150px" alt="location map"
                   (click)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)"
                   (keypress)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)"
                   (keydown)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)"
                   (keyup)="GetCoolerLocation(rowData.latitude,rowData.longitude, rowData.name , rowData, i)" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noData">
            <td [attr.colspan]="columns.length+3">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
  <div class="map-div mb-2">
    <p-tabView #tabView (onChange)="onChange($event)"
               [(activeIndex)]="selectedTabIndex">
      <p-tabPanel header="{{this.labels.mapView | translate}}">
        <ng-template pTemplate="content">
          <div class="cooler_Name" *ngIf="selectedCoolerName == ''">{{ labels.allDevices | translate }}</div>
          <div class="cooler_Name" *ngIf="selectedCoolerName != ''">{{selectedCoolerName}}</div>
          <div class="rectangle-map">
            <leaflet-map></leaflet-map>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

